import {Box, Tooltip} from "@mui/material";
import {t} from "../dashboard/coach/coachTokens";

// Renders the set of companies a Company Group Administrator may impersonate as a row of chips.
// Each chip shows the company name (truncated when long) and reveals the full name on hover.
// When the list overflows `max`, the remaining companies collapse into a "+N" chip whose tooltip
// lists all of them.

const chipSx = {
  display: "inline-flex",
  alignItems: "center",
  maxWidth: 130,
  fontSize: "11px",
  fontWeight: 600,
  lineHeight: 1.6,
  padding: "2px 10px",
  borderRadius: "20px",
  background: t.greenLight,
  color: t.greenText,
  border: "1px solid rgba(1,187,167,.2)",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  cursor: "default",
};

const CompanyChips = ({companies = [], max = 3}) => {
  if (!companies.length) {
    return <Box component="span" sx={{fontSize: "12.5px", color: t.t3}}>—</Box>;
  }

  const visible = companies.slice(0, max);
  const overflow = companies.slice(max);

  return (
      <Box sx={{display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap", justifyContent: "flex-start"}}>
        {visible.map((company) => (
            <Tooltip key={company.id} title={company.name} arrow placement="top">
              <Box component="span" sx={chipSx}>{company.name}</Box>
            </Tooltip>
        ))}
        {overflow.length > 0 && (
            <Tooltip
                arrow
                placement="top"
                title={
                  <Box sx={{display: "flex", flexDirection: "column", gap: "2px", py: 0.25}}>
                    {overflow.map((c) => (
                        <Box key={c.id} component="span" sx={{fontSize: "12px"}}>{c.name}</Box>
                    ))}
                  </Box>
                }
            >
              <Box component="span" sx={{...chipSx, background: t.bg, color: t.t2, border: `1px solid ${t.border}`}}>
                +{overflow.length}
              </Box>
            </Tooltip>
        )}
      </Box>
  );
};

export default CompanyChips;
